export const useHelpers = () => {
    
    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const identifySelectedRequestType = (arraySubtypes, dataToSearch) => {
        const foundValue = arraySubtypes.find(item => item.idmanagementtypes === dataToSearch)

        return (foundValue)? foundValue.prefijo : 'No se ha seleccionado nada'
    }

    const fetchInfoVehiculeReception = (recepcion_codigo, refFetchData) => {}
    
    return Object.freeze({
        getCurrentDate,
        identifySelectedRequestType,
        fetchInfoVehiculeReception
    })
}